import { render, staticRenderFns } from "./BarcodeReturn.vue?vue&type=template&id=d3b40b1a&scoped=true"
import script from "./BarcodeReturn.vue?vue&type=script&lang=js"
export * from "./BarcodeReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b40b1a",
  null
  
)

export default component.exports